import * as API from 'common/constant/routes'
import { getJson } from 'helper/http'
import toSnakeCase from '@deliverance-ai/map-keys-case/to-snake-case'

export const searchAll = (searchTerm, sort, direction, limit, start) => getJson(API.SEARCH_ALL, {}, toSnakeCase({ direction, limit, searchTerm, sort, start }))
